import { Component } from '@angular/core';

@Component({
  selector: 'my-cliente',
  styles: [],
  templateUrl: 'cliente.component.html'
})

export class ClienteComponent {}


// WEBPACK FOOTER //
// ./src/app/cliente/cliente.component.ts